import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { RegisterService } from 'src/app/Services/register.service';

@Component({
  selector: 'app-pid-select',
  templateUrl: './pid-select.component.html',
  styleUrls: ['./pid-select.component.scss']
})

export class PidSelectComponent implements OnInit {

  displayedColumns: string[] = ['select', 'permanent_id', 'institute_name', 'institute_state', 'institute_add'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  onAllUserPaginateChange: any;

  constructor(
    private registerService: RegisterService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<PidSelectComponent>) { }

  ngOnInit(): void {
    this.registerService.getInstitutesList().subscribe(data => this.setInstitutes(data));
  }

  filterObject(obj, filter):boolean{
    // return filter.split(' ').some(
    //   item => obj['CURRENT_INSTITUTE_NAME'].toLowerCase().indexOf(item) >= 0 || 
    //           obj['INSTI_STATE'].toLowerCase().indexOf(item) >= 0 || 
    //           obj['CURRENT_INSTITUTE_ADDRESS'].toLowerCase().indexOf(item) >= 0 || 
    //           obj['PERMANENT_ID'].toLowerCase().indexOf(item) >= 0
    // );

    const matchFilter = [];
    const filterArray = filter.split(' ');
    const columns = (<any>Object).values([
        obj['CURRENT_INSTITUTE_NAME'],
        obj['INSTI_STATE'],
        obj['CURRENT_INSTITUTE_ADDRESS'],
        obj['PERMANENT_ID']
      ]);
    // OR be more specific [data.name, data.race, data.color];
    
    // Main
    filterArray.forEach(filter => {
      const customFilter = [];
      columns.forEach(column => customFilter.push(column.toLowerCase().includes(filter)));
      matchFilter.push(customFilter.some(Boolean)); // OR
    });
    return matchFilter.every(Boolean);
  }

  setInstitutes(data) {

    if (data['type'] == 'Success') {
      this.dataSource = new MatTableDataSource(data['institutes']);
      this.dataSource.filterPredicate = this.filterObject;
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.dataSource.paginator.firstPage;
    } else {
      this.dataSource = new MatTableDataSource([]);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  selectPid(data) {
    this.dialogRef.close({ data: data })
  }

}
